(() => {
  'use strict';
  const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'msclkid'];
  const read = key => { try { return sessionStorage.getItem(key) || ''; } catch (_) { return ''; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch (_) {} };
  const cleanUrl = value => {
    try {
      const url = new URL(value, location.origin);
      const clean = new URL(url.origin + url.pathname);
      [...campaignKeys, 'src'].forEach(key => { if (url.searchParams.has(key)) clean.searchParams.set(key, url.searchParams.get(key)); });
      return clean.href;
    } catch (_) { return ''; }
  };
  const referrerUrl = value => {
    try { const url = new URL(value); return url.origin + url.pathname; } catch (_) { return ''; }
  };
  const bind = form => {
    if (form.dataset.inquiryBound) return;
    form.dataset.inquiryBound = 'true';
    const submit = form.querySelector('[type="submit"]');
    const label = form.querySelector('[data-inquiry-submit-label]');
    const originalLabel = label.textContent;
    const fields = form.querySelector('[data-inquiry-fields]');
    const success = form.querySelector('[data-inquiry-success]');
    const error = form.querySelector('[data-inquiry-error]');
    const initializing = form.querySelector('[data-inquiry-initializing]');
    const honeypot = form.querySelector('[data-inquiry-honeypot]');
    const retryCheck = form.querySelector('[data-inquiry-retry-check]');
    const params = new URLSearchParams(location.search);
    const page = form.dataset.pageHandle;
    const landing = cleanUrl(read('tgb_first_landing_v2') || location.href) || cleanUrl(location.href);
    const originalReferrer = referrerUrl(read('tgb_first_referrer_v1') || document.referrer);
    const landingHandle = new URL(landing).pathname.split('/').filter(Boolean).pop() || 'home';
    const sourcePage = form.dataset.pageKind === 'quote' ? params.get('src') || read('tgb_src_last') || page : page;
    const industryPages = ['healthcare-gifts', 'real-estate-gifts', 'construction-trades-gifts', 'finance-banking-gifts', 'energy-gifts', 'aerospace-defense-gifts', 'tech-startup-gifts', 'legal-gifts', 'insurance-gifts', 'logistics-gifts'];
    if (!read('tgb_first_landing_v2')) write('tgb_first_landing_v2', landing);
    let campaign = {};
    try {
      const storedCampaign = JSON.parse(read('tgb_campaign_click_v2') || '{}');
      if (storedCampaign && typeof storedCampaign === 'object' && !Array.isArray(storedCampaign)) campaign = storedCampaign;
    } catch (_) {}
    const attribution = {
      form_schema: 'tgb_corporate_inquiry_v1',
      lead_source: 'Texas Gift Baskets',
      page_kind: form.dataset.pageKind,
      page_label: form.dataset.pageLabel,
      source_page: sourcePage,
      first_page_seen: read('tgb_src_first') || landingHandle,
      landing_page: landing,
      campaign_landing_page: campaign.landing_page ? cleanUrl(campaign.landing_page) : '',
      submission_page: cleanUrl(location.href),
      referrer: originalReferrer,
      arrived_from: referrerUrl(document.referrer),
      city: sourcePage.endsWith('-corporate-gifts') ? sourcePage.replace(/-corporate-gifts$/, '') : '',
      industry: form.dataset.pageKind === 'industry' ? form.dataset.pageLabel : industryPages.includes(sourcePage) ? sourcePage.replace(/-gifts$/, '') : ''
    };
    campaignKeys.forEach(key => { attribution[key] = campaign[key] || params.get(key) || ''; });
    Object.entries(attribution).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value;
      form.appendChild(input);
    });
    const preview = params.has('preview_theme_id') || params.has('_fd') || window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main';
    const track = name => {
      if (preview) return;
      const detail = { form_id: 'corporate_inquiry', page_kind: attribution.page_kind, page_handle: page };
      try { document.dispatchEvent(new CustomEvent('tgb:inquiry:' + name, { detail })); } catch (_) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', 'tgb_inquiry_' + name, detail); } catch (_) {}
    };
    try {
      if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { track('view'); observer.disconnect(); }
      }, { threshold: 0.25 });
        observer.observe(form);
      }
    } catch (_) {}
    let started = false;
    form.addEventListener('input', event => {
      if (event.target.type !== 'hidden' && event.target !== honeypot && !started) { started = true; track('start'); }
    });
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      let target;
      try { target = new URL(link.href, location.href); } catch (_) { return; }
      const localAnchor = target.origin === location.origin && target.pathname === location.pathname && target.hash === '#corporate-inquiry';
      const quoteLink = target.origin === location.origin && target.pathname.replace(/\/$/, '') === '/pages/get-a-quote';
      if (!localAnchor && !quoteLink) return;
      event.preventDefault();
      const focusTarget = success.hidden ? form.elements.namedItem('full_name') : success;
      form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      focusTarget.focus({ preventScroll: true });
    });
    let state = 'ready';
    const requestId = typeof globalThis.crypto?.randomUUID === 'function' ? globalThis.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (state !== 'ready') return;
      if (honeypot.value.trim()) {
        error.textContent = form.dataset.verificationError;
        error.hidden = false;
        retryCheck.hidden = false;
        error.focus();
        return;
      }
      retryCheck.hidden = true;
      ['full_name', 'email', 'comments'].forEach(name => { const field = form.elements.namedItem(name); field.value = field.value.trim(); });
      if (!form.reportValidity()) return;
      const value = name => String(form.elements.namedItem(name)?.value || '').trim();
      const nameParts = value('full_name').split(/\s+/);
      const lastName = nameParts.pop();
      const payload = {
        ...attribution,
        request_id: requestId,
        full_name: value('full_name'),
        first_name: nameParts.join(' '),
        last_name: lastName,
        email: value('email'),
        phone: value('phone'),
        comments: value('comments'),
        company_name: value('company_name'),
        quantity: value('quantity'),
        budget: value('budget'),
        event_date: value('event_date'),
        multiple_addresses: value('multiple_addresses'),
        occasion: '', best_time: '', company_url: '', zip_code: ''
      };
      state = 'sending';
      submit.disabled = true;
      form.setAttribute('aria-busy', 'true');
      error.hidden = true;
      label.textContent = form.dataset.submitSending;
      track('submit');
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 25000);
      let explicitlyRejected = false;
      try {
        const endpoint = new URL(form.dataset.endpoint);
        if (endpoint.protocol !== 'https:' || endpoint.search || endpoint.hash) throw new Error('Invalid receiving endpoint');
        const response = await fetch(endpoint.href, {
          method: 'POST', mode: 'cors', credentials: 'omit',
          body: JSON.stringify(payload), signal: controller.signal
        });
        if (!response.ok) {
          explicitlyRejected = response.status >= 400 && response.status < 500 && response.status !== 408 && response.status !== 409;
          throw new Error('Submission rejected or unconfirmed');
        }
        const receipt = await response.json();
        if (receipt.status !== 'success') throw new Error('Unconfirmed receipt');
        state = 'received';
        fields.hidden = true;
        success.hidden = false;
        label.textContent = form.dataset.submitReceived;
        success.focus();
        track('received');
      } catch (_) {
        state = explicitlyRejected ? 'ready' : 'uncertain';
        error.textContent = explicitlyRejected ? form.dataset.submitError : form.dataset.submitUncertain;
        error.hidden = false;
        error.focus();
        submit.disabled = !explicitlyRejected;
        label.textContent = originalLabel;
        track(explicitlyRejected ? 'error' : 'uncertain');
      } finally {
        clearTimeout(timer);
        form.removeAttribute('aria-busy');
      }
    });
    retryCheck.addEventListener('click', () => {
      if (state !== 'ready') return;
      honeypot.value = '';
      retryCheck.hidden = true;
      error.hidden = true;
      form.requestSubmit();
    });
    initializing.hidden = true;
    submit.disabled = false;
  };
  const initialize = () => document.querySelectorAll('[data-tgb-inquiry-form]').forEach(form => {
    try { bind(form); } catch (_) {
      const submit = form.querySelector('[type="submit"]');
      const label = form.querySelector('[data-inquiry-submit-label]');
      const initializing = form.querySelector('[data-inquiry-initializing]');
      if (submit) submit.disabled = true;
      if (label) label.textContent = form.dataset.unavailableLabel;
      if (initializing) {
        initializing.textContent = form.dataset.initializationError;
        initializing.hidden = false;
      }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
